// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"504":"chunk-vendors","3057":"index","6851":"chunk-common-a5792c09","7299":"chunk-common-1cf0a49d"}[chunkId] + "." + {"504":"86edc49a","3057":"43162fe1","6851":"6d3786f8","7299":"7b3ec82c"}[chunkId] + ".css";
};